export default {
  methods: {
    async getOrderByFilters(searchFilters) {


      // Order By will also use the nested JSON syntax
      // So we can piggyback off the function that generates the search filters
      // And just pull off what we need for our array we use in the dropdown 

      let orderByFilters = [];

      searchFilters.map((col) => {
        orderByFilters.push({
          label: col.label,
          value: col.id
        })
      })
      return orderByFilters;
    }
  }
};
